import IApiEndpoint from "../types/IApiEndpoint";

const apiEndpoints: Record<string, IApiEndpoint> = {
  category: {
    name: "getCategory",
    method: "GET",
    pathTemplate: "/api/${apiVersion}/campaign/${campaignId}/category/${category}?vendor=${vendor}",
    errorMessage: "CampaignApi (getCategory) failed."
  },
  categories: {
    name: "getAllCategories",
    method: "GET",
    pathTemplate: "/api/${apiVersion}/campaign/${campaignId}/category?vendor=${vendor}",
    errorMessage: "CampaignApi (getAllCategories) failed."
  },
  article: {
    name: "getArticle",
    method: "GET",
    pathTemplate: "/api/${apiVersion}/campaign/${campaignId}/category/${category}/product/${papId}?vendor=${vendor}",
    errorMessage: "CampaignApi (getArticle) failed."
  },
  articles: {
    name: "getAllArticles",
    method: "GET",
    pathTemplate: "/api/${apiVersion}/campaign/${campaignId}/category/${category}/product?vendor=${vendor}",
    errorMessage: "CampaignApi (getAllArticles) failed."
  },
  articleWithExtras: {
    name: "articleWithExtras",
    method: "POST",
    pathTemplate: "/api/${apiVersion}/campaign/${campaignId}/category/${category}/product/${papId}?vendor=${vendor}",
    errorMessage: "CampaignApi (getArticle with extras) failed."
  }
};

export default apiEndpoints;
